import { useState } from "react";
import RoleHierarchyExplorer from "@/components/RoleHierarchyExplorer";
import { Network } from "lucide-react";

export default function PlatformHierarchy() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="admin-platform-hierarchy">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black flex items-center gap-2"><Network className="w-7 h-7 text-primary" /> Role Hierarchy</h1>
        <p className="text-muted-foreground">Live tree of every role across every portal. Edit roles in Role Engine — this updates instantly.</p>
      </div>
      {/* Re-use the public component — it reads the same engine. */}
      <div className="bg-[#0a0a14] rounded-3xl p-6 -mx-2">
        <RoleHierarchyExplorer />
      </div>
    </div>
  );
}
